import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=2cfe4168&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=js&"
export * from "./merchant.vue?vue&type=script&lang=js&"
import style0 from "./merchant.vue?vue&type=style&index=0&id=2cfe4168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe4168",
  null
  
)

export default component.exports